import { Injectable } from '@angular/core'

/**
 * Returns the global window object.
 */
const getWindow = () => window

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  /**
   * Returns the global window object.
   */
  public get window() {
    return getWindow()
  }
}
